import { ModuleRegistry } from 'ag-grid-community'
import { ColumnsToolPanelModule, FiltersToolPanelModule } from 'ag-grid-enterprise'

ModuleRegistry.registerModules([
  ColumnsToolPanelModule,
  FiltersToolPanelModule
])

const defaultPanelLayout = {
  minWidth: 300,
  width: 300
}

export const sideBar = {
  position: 'left',
  toolPanels: [
    {
      id: 'filters',
      labelDefault: 'Filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
      ...defaultPanelLayout
    },
    {
      id: 'columns',
      labelDefault: 'Columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      ...defaultPanelLayout,
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true
      }
    }
  ]
}
